// @flow
import {combineReducers} from 'redux';
import {textInputBlockReducer} from './text-input-block';
import type {TTextInputBlockState} from './text-input-block';

const reducers = {
    textInputBlock: textInputBlockReducer,
};

type TTextInputBlockModuleState = {
    textInputBlock: TTextInputBlockState,
};

const textInputBlockModuleReducer = combineReducers(reducers);
export {textInputBlockModuleReducer};
export type {TTextInputBlockModuleState};
